import { EPostbackCurrency } from '../../enum'

// Create a union type of all possible values from the enum
type IPostbackCurrencyLangKey = `${EPostbackCurrency}`

export type IPostbackCurrencyLang = {
	postback_currency: Record<IPostbackCurrencyLangKey, string>
}

const langEntries = Object.entries(EPostbackCurrency).map(
	([key, value]) => [value, `postback_currency.${value}`]
)

const langObj: Record<IPostbackCurrencyLangKey, string> = Object.fromEntries(langEntries)

export const POSTBACK_CURRENCY_LANG_KEY: IPostbackCurrencyLang = {
	postback_currency: langObj
}
